import { endpoint, dateToServer } from 'services/Api';
import { RESOURCE as PARENT } from 'services/api/miniCalculators';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
const RESOURCE = 'pension';

/**
 * Gross Net Pension Mini Calculator Endpoints:
 */
export default {

    /**
     *
     * @param income
     * @returns promise
     */
    calculate(income) {
        return endpoint(`${PARENT}/${RESOURCE}`, 'gross-net-pension', {
            fiscalYear: income.fiscalYear,
            income: income.income,
            pensionType: income.pensionType.toLowerCase(),
        });
    },
};



// WEBPACK FOOTER //
// ./src/services/api/mini-calculators/grossNetPension.js